import { render, staticRenderFns } from "./Literature.vue?vue&type=template&id=27f5be54&scoped=true"
import script from "./Literature.vue?vue&type=script&lang=js"
export * from "./Literature.vue?vue&type=script&lang=js"
import style0 from "./Literature.vue?vue&type=style&index=0&id=27f5be54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5be54",
  null
  
)

export default component.exports